module.exports = __webpack_public_path__ + "img/pr.53b57cbe.svg";